<script setup lang="ts">
import { computed } from 'vue'
import { useRouter } from 'vue-router'

import PostEditorBeta from '@/views/PostEditorBeta.vue'
import PostEditorLegacy from '@/views/PostEditorLegacy.vue'
import { hasBetaEditorQuery } from '@/utils/editor-variant'

const router = useRouter()

const isBetaEditor = computed(() => hasBetaEditorQuery(router.currentRoute.value.query))
</script>

<template>
    <post-editor-beta v-if="isBetaEditor" />
    <post-editor-legacy v-else />
</template>
